import { render, staticRenderFns } from "./quick-editor.vue?vue&type=template&id=d8617514"
import script from "./quick-editor.vue?vue&type=script&lang=js"
export * from "./quick-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports